import React from 'react'
import { Loader2 } from 'lucide-react'
import { Card } from '@/components/ui/card'
import { BlogPostRow } from './BlogPostRow'

export function BlogPostList({ posts, loading, emptyMessage = 'No blog posts yet.', onEdit, onDuplicate, onArchive, onRestore }) {
  return (
    <Card>
      <div className="flex items-center gap-4 border-b border-border px-4 py-2 text-xs font-medium text-muted-foreground">
        <div className="w-12">Image</div>
        <div className="flex-1">Post</div>
        <div className="w-32 text-center">Category</div>
        <div className="w-24 text-center">Status</div>
        <div className="w-[160px] text-center">Actions</div>
      </div>
      {loading ? (
        <p className="flex items-center gap-2 px-4 py-8 text-sm text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" /> Loading blog posts...
        </p>
      ) : posts.length === 0 ? (
        <p className="px-4 py-8 text-sm text-muted-foreground">{emptyMessage}</p>
      ) : (
        posts.map((post) => (
          <BlogPostRow key={post.id} post={post} onEdit={onEdit} onDuplicate={onDuplicate} onArchive={onArchive} onRestore={onRestore} />
        ))
      )}
    </Card>
  )
}
